<script setup lang="ts">
import { useSyncStore } from '@/stores/sync'
import { useContainerStore } from '@/stores/containers'
import { useContainerTypeStore } from '@/stores/container_types'
import { useRoomStore } from '@/stores/rooms'
import { useIncidentTypeStore } from '@/stores/incident_types'
import { ActionType, getActionTypeLabel } from '@/actions/Action'
import type { NewContainer } from '@/actions/NewContainer'
import type { NewIncident } from '@/actions/NewIncident'
import { getContainerActionLabel, type ContainerMove } from '@/actions/ContainerMove'
import type { ContainerWeighing } from '@/actions/ContainerWeighing'

const props = defineProps({
  show: {
    type: Boolean,
  },
})
const emit = defineEmits(['hide'])

const syncStore = useSyncStore()
const containerStore = useContainerStore()
const containerTypeStore = useContainerTypeStore()
const roomStore = useRoomStore()
const incidentTypeStore = useIncidentTypeStore()
</script>

<template>
  <SuiModal :modelValue="props.show">
    <SuiModalHeader class="sync-modal-header">Synchronisation</SuiModalHeader>
    <SuiModalContent class="sync-modal-content">
      <SuiModalDescription>
        <SuiHeader>Données à synchroniser :</SuiHeader>
        <ol>
          <li v-for="action in syncStore.dataToSync">
            <h3>{{ getActionTypeLabel(action) }}</h3>

            <div v-if="action.type === ActionType.ContainerMove || action.type === ActionType.NewContainer">
              Local : {{ roomStore.findByUuid((action as ContainerMove | NewContainer).payload.roomUuid)?.code }}
            </div>
            <div v-else-if="action.type === ActionType.NewIncident && (action as NewIncident).payload.data.roomUuid">
              Local : {{ roomStore.findByUuid((action as NewIncident).payload.data.roomUuid)?.code }}
            </div>

            <div v-if="action.type === ActionType.NewContainer">
              Bac : {{ (action as NewContainer).payload.code }}
            </div>
            <div v-else-if="action.type === ActionType.NewIncident && (action as NewIncident).payload.data.containerUuid">
              Bac : {{ containerStore.findByUuid((action as NewIncident).payload.data.containerUuid)?.code }}</div>
            <div v-else-if="action.containerCode">
              Bac : {{ action.containerCode }}
            </div>

            <div v-if="action.type === ActionType.ContainerMove">
              Action : {{ getContainerActionLabel(action as ContainerMove) }}
            </div>
            <div v-if="action.type === ActionType.ContainerWeighing">
              Poids : {{ (action as ContainerWeighing).payload.weight }} kg
            </div>
            <div v-if="action.type === ActionType.NewContainer">
              Type : {{ containerTypeStore.findByUuid((action as NewContainer).payload.typeUuid)?.wasteTypeName }}<br/>
              Volume : {{ containerTypeStore.findByUuid((action as NewContainer).payload.typeUuid)?.volume }}
            </div>
            <div v-if="action.type === ActionType.NewIncident">
              Type : {{ incidentTypeStore.findByCode((action as NewIncident).payload.data.typeCode)?.description }}
            </div>
          </li>
        </ol>
        <p>Les données seront synchronisées lorsque la connexion sera retrouvée.</p>
      </SuiModalDescription>
    </SuiModalContent>
    <SuiModalActions>
      <SuiButton @click="emit('hide')">OK</SuiButton>
    </SuiModalActions>
  </SuiModal>
</template>

<style scoped lang="scss">
.sync-modal-header { 
  color: var(--primary-color) !important;
}
.sync-modal-content {
  max-height: 75dvh;
  overflow: auto;

  .ui.header {
    color: var(--primary-color);
  }
  h3 {
    font-size: 1rem;
    margin: 0;
  }
  p {
    margin: 5%;
  }
}
</style>
